import React from 'react'
import { CollapickForm } from '@collapick/form';
import { Grid, Box, Button, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next';
import useEditLevelSchema from '../../FormSchemas/useEditLevelSchema';

const EditLevelForm = (props) => {
    const { title, onSave, onCancel, initialValues, sizeArray, parentTaskDate, helperBaseName, taskType } = props
    const { t } = useTranslation()
    const { editLevelSchema, customValidators } =
        useEditLevelSchema({ initialValues, sizeArray, parentTaskDate, helperBaseName, taskType })

    return (
        <>
            <Grid container justify="center" >
                <Box my={2} >
                    <Typography variant="h2">{title}</Typography>
                </Box>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <CollapickForm
                        formSchema={editLevelSchema}
                        onFormSubmit={onSave}
                        resetFormAfterSubmit={true}
                        renderSubmitButton={() =>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                fullWidth>
                                {t('save')}
                            </Button>}
                        showInvalidSaveButton={true}
                        invalidSubmitText={t("cancel")}
                        onInvalidSubmit={onCancel}
                        initialValues={initialValues}
                        customValidators={customValidators}
                    />
                </Grid>
            </Grid>
        </>
    )
}
export default EditLevelForm